export default __webpack_public_path__ + "static/media/main_logout.226c5b2c.svg";